export default {
      id: "info-usage",
      viewBox: "0 0 14 15",
      url: __webpack_public_path__ + "img/icons.svg#info",
      toString: function () {
        return this.url;
      }
    }